import { Chip, styled } from '@mui/material';

export const TrlPillStatusStyled = styled(Chip)(({ theme }) => ({
  color: theme.palette.colors.mainFocused,
  textTransform: 'uppercase',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: 'normal',
  '& span': {
    padding: '2px 6px',
  },
  height: '20px',
  borderRadius: '4px',
  border: `solid 1px ${theme.palette.colors.mainFocused}`,
  backgroundColor: theme.palette.colors.secondaryBackground,
  [theme.breakpoints.down('md')]: {
    fontSize: '10px',
    height: '16px',
  },
}));
